// extracted by mini-css-extract-plugin
module.exports = {"privacyAlert":"styles_privacyAlert__1eDbQ","privacyLink":"styles_privacyLink__rJAjb","fields":"styles_fields__EtFr0","alert":"styles_alert__3tOvF"};